import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Input } from '../ui/input';
import { useDebouncedValue } from '../sales/useAbortableGet';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Supplier name with suggestions from the SKU Master's Supplier field; any other name can still be typed.
export const SupplierInput = ({ value, onChange, country }) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const query = useDebouncedValue(value, 250);
  const wrapper = useRef(null);

  useEffect(() => {
    if (!open || !query.trim()) { setOptions([]); return undefined; }
    const controller = new AbortController();
    axios.get(`${API}/purchases/supplier-suggestions`, { params: { q: query.trim(), country }, signal: controller.signal })
      .then(res => setOptions(res.data.suppliers)).catch(() => {});
    return () => controller.abort();
  }, [query, open, country]);

  useEffect(() => {
    const close = event => { if (wrapper.current && !wrapper.current.contains(event.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const visible = options.filter(name => name !== value);
  return (
    <div className="relative" ref={wrapper}>
      <Input value={value} onFocus={() => setOpen(true)} onChange={e => { onChange(e.target.value); setOpen(true); }}
        placeholder="Start typing a supplier name" autoComplete="off" data-testid="purchase-supplier-input" />
      {open && visible.length > 0 && (
        <div className="absolute z-50 mt-1 max-h-64 w-full overflow-y-auto rounded-lg border bg-white shadow-lg" data-testid="purchase-supplier-options">
          {visible.map((name, i) => (
            <button type="button" key={name} className="block w-full px-3 py-2 text-left text-[13px] hover:bg-blue-50"
              onClick={() => { onChange(name); setOpen(false); }} data-testid={`purchase-supplier-option-${i}`}>{name}</button>
          ))}
        </div>
      )}
    </div>
  );
};
